import script from "./Depositions.vue?vue&type=script&setup=true&lang=js"
export * from "./Depositions.vue?vue&type=script&setup=true&lang=js"

import "./Depositions.vue?vue&type=style&index=0&id=c848d3fe&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c848d3fe"]])

export default __exports__